import { Tooltip } from 'antd';
import React from 'react';
import { MelioMeSVG } from '@tools/ui/assets';
import useT from '@tools/ui-hooks/useT';

const MelioMeIcon: React.FC<React.PropsWithChildren> = () => {
  const { t } = useT();
  return (
    <Tooltip placement="top" title={t('icons.melioMe')}>
      <MelioMeSVG
        style={{ width: 20, height: 20, display: 'flex', alignItems: 'center' }}
      />
    </Tooltip>
  );
};

export default MelioMeIcon;
